import type { SortOrder, Thought } from "@/core/fastapiClient/sdk";

export function sortThoughtsByDate(
  thoughts: Thought[],
  sortOrder: SortOrder = "descending"
): Thought[] {
  return [...thoughts].sort((a, b) => {
    const dateA = a.latest_at ? new Date(a.latest_at).getTime() : 0;
    const dateB = b.latest_at ? new Date(b.latest_at).getTime() : 0;

    return sortOrder === "ascending" ? dateA - dateB : dateB - dateA;
  });
}
